import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=6447d5c8&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=6447d5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447d5c8",
  null
  
)

export default component.exports